<template>
  <div>
    <page-title
      icon="fa fa-cogs"
      main="Administração"
      sub="Configurações"
      :help="true"
      titleHelp="Ajuda - Configurações"
      content="Responsável por cadastrar configurações.
É possível registrar os Períodos, colocando uma data de início e fim que irá impactar em outras partes do Sistema.
É possível registrar e atualizar Opções de e-mail."
    >
    </page-title>

    <!-- Modals -->
    <modal size="lg" :show.sync="modals.logs" id="cadastrar-seções">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Histórico de Ações</h5>
      </template>
      <el-table
        :data="logs"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
      >
        <el-table-column
          label="Descrição"
          min-width="125px"
          prop="description"
          sortable
        />
        <el-table-column
          label="Data"
          min-width="125px"
          prop="created_at"
          sortable
        />
        <el-table-column
          label="Usuário"
          min-width="150px"
          prop="user_name"
          sortable
        />
        <el-table-column
          label="Modificação"
          min-width="140px"
          prop="changes"
          v-slot="{ row }"
          sortable
        >
          <div v-html="formatChanges(row.changes)"></div>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <base-button type="secondary" @click="modals.logs = false"
          >Fechar</base-button
        >
      </template>
    </modal>

    <!-- Page data -->
    <card>
      <div slot="header">
        <span>Configurações</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-12">
            <div
              v-for="(setting_options, setting_category, index) in setting"
              :key="'outer' + index"
            >
              <div class="row">
                <div class="col-auto">
                  <h2>{{ translation[setting_category] }}</h2>
                </div>
                <div class="col-auto">
                  <base-button
                    size="sm"
                    type="secondary"
                    @click="showLog(setting_category)"
                    ><i class="fas fa-history text-blue"></i
                  ></base-button>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-12 col-md-6"
                  v-for="(setting_value = {}, setting_name, inner_index) in setting_options"
                  :key="'inner' + inner_index"
                >
                  <!-- Label -->
                  <label
                    class="form-control-label"
                    v-if="setting_value.localization"
                    v-text="setting_value.localization"
                  ></label>

                  <!-- Helper -->
                  <el-popover
                    trigger="hover"
                    placement="top"
                    v-if="setting_value.description"
                  >
                    <p
                      v-text="setting_value.description"
                      style="max-width: 300px; word-break: keep-all;"
                    ></p>
                    <i
                      slot="reference"
                      class="fa fa-question-circle"
                      style="margin-left: 10px;"
                    ></i>
                  </el-popover>

                  <!-- Input -->
                  <div
                    v-if="setting_value.type == 'date'"
                    :key="'input' + index + inner_index + 'date'"
                  >
                    <base-input
                      addon-left-icon="ni ni-calendar-grid-58"
                    >
                    <flat-picker
                      class="form-control datepicker"
                      :config="{
                        allowInput: true,
                        dateFormat: 'd/m/Y',
                        locale: 'pt',
                      }"
                      v-model="setting[setting_category][setting_name].value"
                    ></flat-picker>
                    </base-input>
                  </div>
                  <div
                    v-else-if="setting_value.type == 'number'"
                    :key="'input' + index + inner_index + 'number'"
                  >
                    <base-input
                      addon-left-icon="ni ni-calendar-grid-58"
                      type="number"
                      v-model="setting[setting_category][setting_name].value"
                    />
                  </div>
                  <div
                    v-else-if="setting_value.type == 'password'"
                    :key="'input' + index + inner_index + 'password'"
                  >
                    <PasswordInput
                      :key="'input' + index + inner_index"
                      addon-left-icon="ni ni-calendar-grid-58"
                      type="password"
                      label=""
                      v-model="setting[setting_category][setting_name].value"
                    />
                  </div> 
                  <div v-else-if="setting_value.type == 'select'">
                    <multiselect
                      v-model="setting[setting_category][setting_name].value"
                      placeholder="Selecionar"
                      :options="filteredTables"
                      :multiple="true"
                      :limit="1"
                      :limit-text="limitText"
                      :close-on-select="false"
                      :loading="isLoadingTables"
                    >
                      <template slot="beforeList">
                        <div
                          @click="toggleSelectAll(setting_category, setting_name)"
                          :class="allSelected(setting_category, setting_name) ? 'all-selected' : 'multiple'"
                          :style="allSelected(setting_category, setting_name) ? 'background-color: #e9ecef; color: #212529' : ''"
                        >
                          <span :style="allSelected(setting_category, setting_name) ? 'font-weight: 700' : ''">
                            {{ allSelected(setting_category, setting_name) ? 'Desmarcar todas' : 'Selecionar todas' }}
                          </span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                  <div
                    class="mb-4"
                    v-else-if="setting_value.type == 'analytical_goal_column'"
                  >
                    <multiselect
                      v-model="setting[setting_category][setting_name].value"
                      placeholder="Selecionar"
                      :options="tableColumn"
                      :multiple="true"
                      :limit="1"
                      :limit-text="limitText"
                      :close-on-select="false"
                    >
                      <template slot="beforeList">
                        <div
                          @click="toggleSelectAllColumns(setting_category, setting_name)"
                          :class="allSelectedColumns(setting_category, setting_name) ? 'all-selected' : 'multiple'"
                          :style="allSelectedColumns(setting_category, setting_name) ? 'background-color: #e9ecef; color: #212529' : ''"
                        >
                          <span :style="allSelectedColumns(setting_category, setting_name) ? 'font-weight: 700' : ''">
                            {{ allSelectedColumns(setting_category, setting_name) ? 'Desmarcar todas' : 'Selecionar todas' }}
                          </span>
                        </div>
                      </template>
                    </multiselect>                  
                  </div>
                  <div 
                    v-else-if="setting_value.subtype === 'image'"
                    :key="'input' + index + inner_index + 'image'"
                    class="mb-4"
                  >
                    <div>
                      <file-input
                        class="col-10 custom-file-override"
                        :initialLabel="setting[setting_category][setting_name].selectedImage || 'Alterar Imagem'"
                        @input="handleFileChange($event, setting_category, setting_name)"
                        accept="image/jpeg, image/png, image/svg+xml, image/tiff, image/gif"
                      />
                      <base-button 
                        icon 
                        class="ml-2 mt-2"
                        type="danger"
                        size="sm"
                        v-if="!isDefaultImage(setting_category, setting_name)" 
                        @click="removeFile(setting_category, setting_name)"
                      ><i class="fa fa-times"/>
                      </base-button>
                      <div>
                        <small class="text-danger" v-if="errors[setting_name]">{{ errors[setting_name] }}</small>
                      </div>
                    </div>
                    <div>
                      <img
                        v-loading="loadingImage"
                        style="max-height: 100px; margin-top: 2vh; justify-items: center;"
                        :src="setting[setting_category][setting_name].value"
                        v-if="setting[setting_category][setting_name].value"
                      />
                    </div>
                  </div>
                  <div
                    v-else
                    :key="'input' + index + inner_index + 'string'"
                  >
                    <base-input
                      :key="'input' + index + inner_index"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="setting[setting_category][setting_name].value"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button type="success" @click="save">Salvar</base-button>
      </template>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Table, TableColumn, Popover, DatePicker } from "element-ui";
import swal from "sweetalert2";
import "flatpickr/dist/l10n/pt.js";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import PasswordInput from "../../components/Inputs/PasswordInput.vue";

export default {
  name: "app",
  components: {
    PageTitle,
    flatPicker,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    [Popover.name]: Popover,
    [DatePicker.name]: DatePicker,
    Multiselect,
    PasswordInput,
  },
  data() {
    return {
      loadingImage: false,
      setting_attributes: [],
      setting: {},
      dateSetting: {},
      errors: {},
      modals: {
        logs: false,
      },
      logs: [],
      isLoadingLogs: false,
      translation: {
        goal_periods: "Periodos de Metas",
        client_review: "Carteiras de    ",
        schedule_review: "Visitas a Clientes",
        avaliation_review: "Opções de Avaliações",
        nps_avaliations: "Avaliação NPS",
        mail_options: "Opções de Email",
        commercial_configurations: "Configuração Condição Comercial",
        analytical_goal_column_configurations: "Configuração Coluna Meta Analítica",
        image_adjustments: "Ajustes de Imagens"
      },
      tables_erp: [],
      isLoadingTables: false,
      allSelectedActive: false,
      selectedValue:[],
      tableColumn: ['Marca', 'Meta KG/LT', 'Vol. Realizado', 'Meta (R$)', 'R$ Realizado', 'Meta Realizado (%)',
        'Meta Financeiro (%)', 'Vol. Meta Estratégico', 'Meta Realizado Estratégico (%)', 'Estratégico (R$)',
        'Meta Realizado Estratégico Financeiro (%)', 'Quantidade do Pedido Em Carteira', 'Pedido em Carteira R$',
        'Pedido em Carteira R$', 'Meta Realizada Total (%)', 'Meta Realizada Total Financeiro (%)', 'Todas'
      ],
    };
  },
  mounted() {
    this.getSettingsAttributes();
    this.getTablesErp();
    this.updateCurrentOptions();
  },
  methods: {
    getDefaultImage(setting_name) {
      const defaultImages = {
        logo_sgv: "/img/brand/top-logo.png",
        notice_board: "",
        background_sgv: "/img/backgrounds/farm-1.jpg",
        background_ppr: "/img/backgrounds/farm-4.jpg",
        background_login: `/img/backgrounds/farm-${Math.floor(Math.random() * 3)}.jpg`,
      };
      return defaultImages[setting_name] || null;
    },
    isDefaultImage(setting_category, setting_name) {
      return this.setting[setting_category][setting_name].value === this.getDefaultImage(setting_name);
    },
    setDefaultImage(setting_category, setting_name) {
      this.setting[setting_category][setting_name].value = this.getDefaultImage(setting_name);
      this.$set(this.errors, setting_name, "");
    },
    removeFile(setting_category, setting_name) {
      if (this.isDefaultImage(setting_category, setting_name)) {
        return;
      }

      swal
        .fire({
          title: `Redefinir para imagem padrão`,
          text: `A imagem atual será removida e substituída pela imagem padrão definida no sistema.`,
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary mr-2",
          cancelButtonClass: "btn btn-secondary",
        }) 
        .then((result) => {
          if (result.isConfirmed) {
            this.setDefaultImage(setting_category, setting_name);
          }
        });
    },
    handleFileChange(event, setting_category, setting_name) {
      const file = event.target.files[0];
      if (!file) return;

      this.$set(this.errors, setting_name, "");

      const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml", "image/tiff", "image/gif"];
      if (!allowedTypes.includes(file.type)) {
        this.$set(this.errors, setting_name, "Formato inválido! Apenas JPG, PNG, SVG, TIFF e GIF são permitidos.");
        return;
      }

      const imageConstraints = {
        logo_sgv:         { width: 545,  height: 500 },
        background_sgv:   { width: 1040, height: 571 },
        background_ppr:   { width: 1040, height: 571 },
        background_login: { width: 1422, height: 800 },
      };

      const expectedSize = imageConstraints[setting_name];

      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width !== expectedSize.width || img.height !== expectedSize.height) {
          this.$set(
            this.errors,
            setting_name,
            `Dimensão inválida! Esperado: ${expectedSize.width}x${expectedSize.height}px`
          );
          return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          this.setting[setting_category][setting_name].value = reader.result;
          this.$set(this.setting[setting_category][setting_name], "selectedImage", file.name);
        };
        reader.readAsDataURL(file);
      };
    },
    async getSettingsAttributes() {
      this.loadingImage = true
      try {
        const response = await this.$http.secured.get("/api/v1/admin/settings");
        this.setting = response.data;

        for (const setting_category in this.setting) {
          for (const setting_name in this.setting[setting_category]) {
            if (!this.setting[setting_category][setting_name].value) {
              this.setting[setting_category][setting_name].value = this.getDefaultImage(setting_name);
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingImage = true
      }
    },
    async getTablesErp() {
      this.isLoadingTables = true;
      try {
        const response = await this.$http.secured.get("/api/v1/table_erps");
        this.tables_erp = response.data;
      } catch (error) {
        this.setError(error, "failed to fetch tables_erp");
      } finally {
        this.isLoadingTables = false;
      }
    },
    async getLogs(setting) {
      this.isLoadingLogs = true;
      try {
        const response = await this.$http.secured.get("/api/v1/report/versions", {
          params: {
            "version[item_type]": "Setting",
            "version[object]": setting,
          },
        })
        this.logs = response.data.versions;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoadingLogs = false;
      }
    },
    async save() {
      try {
        const response = await this.getDescription();
        
        if (response.isDismissed) return;

        await this.$http.secured.patch("/api/v1/admin/settings", {
          setting: this.setting,
          description: response.value,
        });

        this.$toasted.global.defaultSuccess({ msg: "Operação realizada com sucesso!" });
        await this.$store.dispatch("fetchImageSettings");
      } catch (error) {
        console.log(error);
      }
    },
    getDescription() {
      return swal.fire({
        title: `Informe a descrição da alteração`,
        text: `Digite o Motivo da alteração`,
        input: "text",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-primary",
      });
    },
    limitText(count){
      return `+ ${count}`;
    },
    showLog(setting) {
      this.getLogs(setting);
      this.modals.logs = true;
    },
    formatChanges(html) {
      return html
        .replaceAll(/^<br>|(&nbsp;|\s|<br>)*value:(&nbsp;|\s|<br>)*/g, "")
        .replaceAll(/\w+:(?![A-z0-9\/\\\s-_.,'"]+(<br>|$))/g, "")
        .replaceAll(/\w+\:/g, "");
    },
    toggleSelectAllColumns(setting_category, setting_name) {
      const currentValues = this.setting[setting_category][setting_name].value;
      const options = this.tableColumn;

      if (this.allSelectedColumns(setting_category, setting_name)) {
        this.setting[setting_category][setting_name].value = [];
      } else {
        this.setting[setting_category][setting_name].value = [...options];
      }
    },
    allSelectedColumns(setting_category, setting_name) {
      const currentValues = this.setting[setting_category][setting_name].value;
      const options = this.tableColumn;

      return Array.isArray(options) && options.length > 0 && Array.isArray(currentValues) && currentValues.length === options.length;
    },
    toggleSelectAll(setting_category, setting_name) {
      const currentValues = this.setting[setting_category][setting_name].value;
      const options = this.filteredTables;

      if (this.allSelected(setting_category, setting_name)) {
        this.setting[setting_category][setting_name].value = [];
      } else {
        this.setting[setting_category][setting_name].value = [...options];
      }
    },
    allSelected(setting_category, setting_name) {
      const currentValues = this.setting[setting_category][setting_name].value;
      const options = this.filteredTables;

      return Array.isArray(options) && options.length > 0 && Array.isArray(currentValues) && currentValues.length === options.length;
    },
  },
  computed: {
    filteredTables(){
      return this.tables_erp.map(table => table.desc_cta).sort((a, b) => a.localeCompare(b));
    },
  },
};
</script>
<style scoped>
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
}
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
::v-deep(.custom-file-label::after) {
  content: "Upload" !important;
}
</style>